import API from '../../../../axios';

/**
 * REST layer of Inicio, `/human-tasks/*` (spec §6), on the main axios client
 * (Bearer token + Sentry trace headers). `companyId` and `userId` come from
 * the token on the backend, never from the body. Every call resolves to the
 * raw body; the mappers turn it into view models.
 */
const BASE = '/human-tasks';
const taskPath = (id, action) => `${BASE}/${encodeURIComponent(id)}/${action}`;
const body = (response) => response && response.data;

export const humanTasksRestApi = {
  /** Visible, every task in progress, today's progress and counters. Also records the user's presence. */
  getMyTasks: () => API.get(`${BASE}/me`).then(body),
  take: (id) => API.post(taskPath(id, 'take'), {}).then(body),
  pause: (id) => API.post(taskPath(id, 'pause'), {}).then(body),
  resume: (id) => API.post(taskPath(id, 'resume'), {}).then(body),
  skip: (id, { reason, confirmHumanOnly } = {}) =>
    API.post(taskPath(id, 'skip'), { reason, confirmHumanOnly: confirmHumanOnly === true }).then(body),
  close: (id, { outcomeId, note } = {}) => {
    const trimmed = typeof note === 'string' ? note.trim() : '';
    return API.post(taskPath(id, 'close'), trimmed ? { outcomeId, note: trimmed } : { outcomeId }).then(body);
  },
  /** «Devolver al Agente IA» (D30): a shared task in progress ends with no outcome. A human-only one answers HUMAN_ONLY. */
  returnToAi: (id) => API.post(taskPath(id, 'return-to-ai'), {}).then(body),
  getMyStats: (range = 'today') => API.get(`${BASE}/stats/me`, { params: { range } }).then(body),
  /** Requires the `taskStats` permission on the backend. */
  getTeamStats: (range = 'today') => API.get(`${BASE}/stats/team`, { params: { range } }).then(body),
};

export default humanTasksRestApi;
